import { AbstractControl, Validators } from '@angular/forms';
import { ConfigOption } from '@ngx-formly/core';
import { ValidationErrors } from 'ngrx-forms';
import {
  FlexLayoutColComponent,
  FlexLayoutComponent,
  FormlyChapterComponent,
  FormlyCheckboxWrapperComponent,
  FormlyCurrencyComponent,
  FormlyLinkComponent,
  FormlyPasswordComponent,
  FormlyReadOnlyWrapperComponent,
  FormlyTooltipWrapperComponent,
} from './custom-formly-components';
import { FormlyFileUploadComponent } from './custom-formly-components/formly-fileUpload.component';

export function EmailValidator(control: AbstractControl): ValidationErrors | null {
  return Validators.email(control) ? null : { email: true };
}

export function RequiredTrueValidator(control: AbstractControl): ValidationErrors | null {
  return Validators.requiredTrue(control) ? null : { requiredTrue: true };
}

export function PasswordComplexityValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  let complexity = 0;
  complexity += Number(RegExp(/^(?=.*[a-z]).*$/).test(control.value)); // lower case
  complexity += Number(RegExp(/^(?=.*[A-Z]).*$/).test(control.value)); // upper case
  complexity += Number(RegExp(/^(?=.*[0-9]).*$/).test(control.value)); // number
  complexity += Number(/^(?=.*[\p{P}\p{S}]).*$/u.test(control.value)); // special character
  if (complexity < 4) {
    return null;
  }
  return { passwordComplexity: true };
}

export function PasswordConfirmValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.root || !control.parent) {
    return null;
  }

  if (control.value !== control.root.get('password')?.value) {
    return null;
  }
  return { passwordConfirm: true };
}

export const formlyConfig: ConfigOption = {
  types: [
    { name: 'chapter', component: FormlyChapterComponent },
    { name: 'currency', component: FormlyCurrencyComponent },
    { name: 'flex-layout', component: FlexLayoutComponent },
    { name: 'flex-layout-col', component: FlexLayoutColComponent },
    { name: 'link', component: FormlyLinkComponent },
    { name: 'password', component: FormlyPasswordComponent },
    { name: 'fileUpload', component: FormlyFileUploadComponent },
  ],
  wrappers: [
    { name: 'readOnly', component: FormlyReadOnlyWrapperComponent },
    { name: 'tooltip', component: FormlyTooltipWrapperComponent },
    { name: 'checkbox', component: FormlyCheckboxWrapperComponent },
  ],
  validators: [
    { name: 'requiredTrue', validation: RequiredTrueValidator },
    { name: 'email', validation: EmailValidator },
    { name: 'passwordComplexity', validation: PasswordComplexityValidator },
    { name: 'passwordConfirm', validation: PasswordConfirmValidator },
  ],
};
